<div class="control-section" *ngIf="chartData && chartComplete; else loadingSubmissionChart">
  <ejs-chart id="chart-container-submitted" [chartArea]="chartArea" [primaryXAxis]='primaryXAxis'
    [primaryYAxis]='primaryYAxis' [title]='chartTitle' [legendSettings]="legendSettings" [titleStyle]='titleStyle'
    [subTitleStyle]="subtitleStyle" [tooltip]='tooltip' (textRender)="onTextRender($event)"
    [enableAnimation]='enableAnimation' selectionMode="Series" background='#fff' enableComplexProperty=true
    [subTitle]="subTitle" (load)="load($event)" (chartMouseClick)='chartMouseClick($event)'>
    <e-series-collection>
      <e-series [dataSource]='chartData' type='Column' xName='channel' yName='inprocess' name='In Process'
        columnWidth=0.96 [marker]='marker' legendShape='Rectangle' [cornerRadius]='radius' fill="#0071bb">
      </e-series>
      <e-series [dataSource]='chartData' type='Column' xName='channel' yName='success' name='Success' columnWidth=1
        [marker]='marker' legendShape='Rectangle' [cornerRadius]='radius' fill="#29A829"></e-series>
      <e-series [dataSource]='chartData' type='Column' xName='channel' yName='fail' name='Fail' columnWidth=1
        [marker]='marker' legendShape='Rectangle' [cornerRadius]='radius' fill="#FF3131"
        tooltipMappingName='channel'></e-series>
    </e-series-collection>
  </ejs-chart>
</div>

<ng-template #loadingSubmissionChart>
  <div class="col-sm-12 chart-spinner-div">
    <div class="col-sm-10 center-block loading-chart-message">
      Loading chart <br>Device Submissions by Health Authority
      <span class="loading-dots loading-dots-font">
        <span>.</span><span>.</span><span>.</span>
      </span>
    </div>
    <div id="loadingCharts"></div>
  </div>
</ng-template>
